import { URL_APP_ADMIN, URL_PARTNER_BASE } from '../../../utils/routing/routes'

export const LOCAL_STORAGE_REDIRECT_KEY = 'defaultRedirectOverride'
export const TERMS_REDIRECT_KEY = 'termsRedirectOverride'

export const consumeStoredRedirectUrl = (storageKey = LOCAL_STORAGE_REDIRECT_KEY) => {
  const target = sessionStorage.getItem(storageKey)
  sessionStorage.removeItem(storageKey)
  return target
}

interface StoreRedirectUrlProps {
  pathname: Location['pathname']
  search?: Location['search']
  hash?: Location['hash']
  storageKey?: string
}

export const storeRedirectUrl = ({
  pathname,
  search,
  hash,
  storageKey = LOCAL_STORAGE_REDIRECT_KEY,
}: StoreRedirectUrlProps) => {
  if (![URL_PARTNER_BASE, URL_APP_ADMIN].some(prefix => pathname.startsWith(prefix))) return

  sessionStorage.setItem(storageKey, `${pathname}${search ? search : ''}${hash ? hash : ''}`)
}

export const storeCurrentRedirectUrl = (storageKey = LOCAL_STORAGE_REDIRECT_KEY) => {
  storeRedirectUrl({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    storageKey,
  })
}
